import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "carousel", "pageLabel", "dots", "prevBtn", "nextBtn"]

  static values = {
    currentPage: { type: Number, default: 0 },
    totalPages: { type: Number, default: 0 },
    images: { type: Array, default: [] },
    pdfMode: { type: Boolean, default: false }
  }

  open(event) {
    const images = event.params.images || []
    if (images.length === 0) return

    this.pdfModeValue = false
    this.imagesValue = images
    this.totalPagesValue = images.length
    this.currentPageValue = 0

    this.populateCarousel(images)
    this.updateDots()
    this.updatePageLabel()
    this.updateNavButtons()
    this.showNavigation()

    this.overlayTarget.classList.add("open")
    document.body.style.overflow = "hidden"
  }

  openPdf(event) {
    const pdfUrl = event.params.pdfUrl
    if (!pdfUrl) return

    this.pdfModeValue = true
    this.carouselTarget.innerHTML = ""
    this.dotsTarget.innerHTML = ""
    this.pageLabelTarget.textContent = ""
    this.hideNavigation()

    const embed = document.createElement("iframe")
    embed.src = pdfUrl
    embed.type = "application/pdf"
    embed.style.cssText = "width:100%;height:100%;border:none;"
    embed.title = "Extrait BD"

    this.carouselTarget.appendChild(embed)
    this.carouselTarget.style.transform = "none"

    this.overlayTarget.classList.add("open")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.overlayTarget.classList.remove("open")
    document.body.style.overflow = ""
    this.carouselTarget.innerHTML = ""
    this.dotsTarget.innerHTML = ""
    this.currentPageValue = 0
    this.totalPagesValue = 0
    this.imagesValue = []
    this.pdfModeValue = false
    this.showNavigation()
  }

  next() {
    if (this.pdfModeValue) return
    if (this.currentPageValue < this.totalPagesValue - 1) {
      this.currentPageValue++
      this.updateCarouselPosition()
      this.updateDots()
      this.updatePageLabel()
      this.updateNavButtons()
    }
  }

  prev() {
    if (this.pdfModeValue) return
    if (this.currentPageValue > 0) {
      this.currentPageValue--
      this.updateCarouselPosition()
      this.updateDots()
      this.updatePageLabel()
      this.updateNavButtons()
    }
  }

  goToPage(event) {
    const page = parseInt(event.currentTarget.dataset.page, 10)
    if (page >= 0 && page < this.totalPagesValue) {
      this.currentPageValue = page
      this.updateCarouselPosition()
      this.updateDots()
      this.updatePageLabel()
      this.updateNavButtons()
    }
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  keydown(event) {
    if (!this.overlayTarget.classList.contains("open")) return

    if (event.key === "Escape") this.close()
    if (this.pdfModeValue) return
    if (event.key === "ArrowRight") this.next()
    if (event.key === "ArrowLeft") this.prev()
  }

  // Private

  populateCarousel(images) {
    this.carouselTarget.innerHTML = ""

    images.forEach((url) => {
      const page = document.createElement("div")
      page.classList.add("bd-modal-page")

      const img = document.createElement("img")
      img.src = url
      img.alt = "Extrait BD"
      img.loading = "lazy"

      page.appendChild(img)
      this.carouselTarget.appendChild(page)
    })

    this.carouselTarget.style.transform = "translateX(0%)"
  }

  updateCarouselPosition() {
    const offset = this.currentPageValue * 100
    this.carouselTarget.style.transform = `translateX(-${offset}%)`
  }

  updateDots() {
    this.dotsTarget.innerHTML = ""

    for (let i = 0; i < this.totalPagesValue; i++) {
      const dot = document.createElement("button")
      dot.classList.add("bd-modal-dot")
      dot.dataset.page = i
      dot.dataset.action = "bd-excerpt-modal#goToPage"

      if (i === this.currentPageValue) {
        dot.classList.add("active")
      }

      this.dotsTarget.appendChild(dot)
    }
  }

  updatePageLabel() {
    this.pageLabelTarget.textContent = `Page ${this.currentPageValue + 1} / ${this.totalPagesValue}`
  }

  updateNavButtons() {
    this.prevBtnTarget.disabled = this.currentPageValue === 0
    this.nextBtnTarget.disabled = this.currentPageValue === this.totalPagesValue - 1
  }

  hideNavigation() {
    this.prevBtnTarget.style.display = "none"
    this.nextBtnTarget.style.display = "none"
  }

  showNavigation() {
    this.prevBtnTarget.style.display = ""
    this.nextBtnTarget.style.display = ""
  }
}
